(() => {
  if (window.__faizCouponCodesInitialized) return;
  window.__faizCouponCodesInitialized = true;

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch (error) {
        // Use the fallback below when clipboard permission is unavailable.
      }
    }

    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    return copied;
  };

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-fn-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.fnOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-fn-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog[data-fn-dialog]');
      if (dialog) dialog.close();
      return;
    }

    const dialog = event.target.closest('dialog[data-fn-dialog]');
    if (dialog && event.target === dialog) {
      dialog.close();
      return;
    }

    const copyButton = event.target.closest('[data-fn-copy]');
    if (!copyButton) return;

    const root = copyButton.closest('[data-fn-coupon]');
    const status = root && root.querySelector('[data-fn-status]');
    const code = copyButton.dataset.fnCopy;
    try {
      const copied = await copyText(code);
      if (status) {
        const prefix = root.dataset.fnCopied || 'Code copied';
        status.textContent = copied ? `${prefix}: ${code}` : `Copy this code: ${code}`;
      }
    } catch (error) {
      if (status) status.textContent = `Copy this code: ${code}`;
    }
  });
})();
